import { render, staticRenderFns } from "./shortcutdate.vue?vue&type=template&id=a390c336&scoped=true"
import script from "./shortcutdate.vue?vue&type=script&lang=ts"
export * from "./shortcutdate.vue?vue&type=script&lang=ts"
import style0 from "./shortcutdate.vue?vue&type=style&index=0&id=a390c336&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a390c336",
  null
  
)

export default component.exports